import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { forceCorrectLoginPageGuard } from '@guards/force-correct-login-page.guard';
import { redirectIfActiveGuard } from '@guards/redirect-if-active.guard';
import { LoginPageRolesByRoute } from '../shared/enums/login-page-type';
import {
  ChooseLoginRedesignHandlerComponent
} from './choose-login/choose-login-redesign-handler/choose-login-redesign-handler.component';
import {
  ForgotPasswordHandlerComponent
} from './forgot-password/forgot-password-handler/forgot-password-handler.component';
import { InvalidTokenComponent } from './invalid-token/invalid-token.component';
import { LoginStudentHandlerComponent } from './login-student-handler/login-student-handler.component';
import { LoginUserHandlerComponent } from './login-user-handler/login-user-handler.component';
import { LoginComponent } from './login.component';
import { SkofLoginComponent } from './login.skof/login.skof.component';
import { LtiAdvantageRedirectComponent } from './lti-advantage-redirect/lti-advantage-redirect.component';
import { LtiAdvantageRequestComponent } from './lti-advantage-request/lti-advantage-request.component';
import { LtiTokenExchangeComponent } from './lti-token-exchange/lti-token-exchange.component';
import { OAuth2Component } from './oauth2/oauth2.component';
import { SetupAccountHandlerComponent } from './setup-account-handler/setup-account-handler.component';

const routes: Routes = [
  {
    path: 'login',
    canActivate: [
      forceCorrectLoginPageGuard,
      redirectIfActiveGuard
    ],
    children: [
      { path: '', component: ChooseLoginRedesignHandlerComponent },
      { path: 'teacher', redirectTo: 'user' },
      // The formMode property  will toggle the form between parent, teacher/admin, and student.
      { path: 'parent', component: LoginUserHandlerComponent, data: { formMode: LoginPageRolesByRoute.Parent } },
      { path: 'user', component: LoginUserHandlerComponent, data: { formMode: LoginPageRolesByRoute.User } },
      { path: 'student', component: LoginStudentHandlerComponent, data: { formMode: LoginPageRolesByRoute.Student } },
    ],
  },
  { // forgot password needs to bypass forceCorrectLoginPageGuard
    path: 'login',
    canActivate: [redirectIfActiveGuard],
    component: LoginComponent,
    children: [{ path: 'forgot-password', component: ForgotPasswordHandlerComponent }]
  },
  { path: 'login/skof', component: SkofLoginComponent, canActivate: [redirectIfActiveGuard] },
  { path: 'set-password', component: SetupAccountHandlerComponent },
  { path: 'lti-token-exchange', canActivate: [redirectIfActiveGuard], component: LtiTokenExchangeComponent },
  { path: 'account-setup', canActivate: [redirectIfActiveGuard], component: SetupAccountHandlerComponent },
  { path: 'invalid-token', canActivate: [redirectIfActiveGuard], component: InvalidTokenComponent },
  // The clever path is maintained for backwards-compatibility.
  { path: 'clever', component: OAuth2Component },
  { path: 'oauth2/:provider', component: OAuth2Component },
  { path: 'lti-advantage-request', component: LtiAdvantageRequestComponent },
  { path: 'lti-advantage-redirect', component: LtiAdvantageRedirectComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class LoginRoutingModule { }
